import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./styles/Intro.css";

const Intro = () => {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    const timer = setTimeout(() => {
      loginWithRedirect();
    }, 1000); // 1 second (1000ms)

    return () => clearTimeout(timer); // Cleanup on unmount
  });

  return (
    <div className="intro-page">
      <img className="intro-page-logo" src="/images/LoadingIntroBunny.png" alt="Loading Bunny" />
      {/* <div className="loading-spinner"></div> */}
      {/* <h1>Welcome to BunnyKlawz Booking</h1>
      <p>Please log in or sign up to continue.</p>
      <button onClick={() => loginWithRedirect()}>Login</button>
      <button
        onClick={() =>
          loginWithRedirect({ authorizationParams: { screen_hint: "signup" } })
        }
      >
        Signup
      </button> */}
    </div>
  );
};

export default Intro;